jQuery( document ).ready( function() {
	jQuery( '.ajax-load-more' ).on( 'click', function() {
		const button = jQuery( this );
		const slug = button.data( 'category-slug' );
		const paged = parseInt( button.data( 'paged' ) );
		const maxPages = parseInt( button.data( 'max-num-pages' ) );
		jQuery( '.loader-container' ).show();
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'ajax_filter_load_more',
				slug,
				paged,
			},
			success( response ) {
				jQuery( '.loader-container' ).hide();
				if ( response.success && response.data ) {
					if ( paged + 1 > maxPages ) {
						button.parent().remove();
					} else {
						button.data( 'paged', paged + 1 );
					}
					jQuery( '.' + slug ).append( response.data );
				} else {
					button.remove();
				}
			},
		} );
	} );
} );
